// Экран просмотра элемента внутри пикера. Отдельным компонентом, потому что
// диалог теперь переключает два самостоятельных экрана — выбор и просмотр, — и
// держать оба в одном теле значит читать раскладку через развилку на каждой ветке.
//
// Просмотр живёт ВНУТРИ окна выбора, а не вторым диалогом: деталь несёт свой
// лайтбокс, а он поверх двух вложенных Radix-модалок теряет клики (нижний слой
// считает их «снаружи» и закрывает пикер).

import type { TFunction } from "i18next";

import { ElementDetails, ElementLightbox, toElementDetailsView } from "~/entities/element";
import { Button } from "~/shared/ui/button";
import { DialogFooter } from "~/shared/ui/dialog";

import type { Element, ElementLightboxState } from "~/entities/element";

interface ElementPickerDetailsProps {
    t: TFunction;
    element: Element;
    lightbox: ElementLightboxState;
    onBack: () => void;
}

export function ElementPickerDetails({ t, element, lightbox, onBack }: ElementPickerDetailsProps) {
    return (
        <>
            <ElementDetails t={t} view={toElementDetailsView(t, element)} onOpenImage={lightbox.open} />
            <ElementLightbox
                images={element.images.map((image) => image.s3Url)}
                caption={element.name}
                index={lightbox.index}
                onClose={lightbox.close}
            />
            <DialogFooter>
                <Button type="button" variant="ghost" onClick={onBack}>
                    {t("elements:details.back")}
                </Button>
            </DialogFooter>
        </>
    );
}
